import { FiltersImpl } from './filtersImpl';

export { getIsFilterSupported } from './getIsFilterSupported';
export { getConfigurationFilterId } from './getConfigurationFilterId';
export { getConfigurationFilterObjectUrl } from './getConfigurationFilterObjectUrl';

export type FilterSettings = Record<string, number>;

let filtersImpl: Promise<FiltersImpl>;
function getFiltersImpl() {
  if (!filtersImpl) {
    filtersImpl = import(/* webpackChunkName: 'filters' */ './filtersImpl');
  }
  return filtersImpl;
}

export function initFilterPreview(
  cid: number,
  designId: string,
  filterSettings: FilterSettings,
  filterDesignId?: string
) {
  return getFiltersImpl().then(({ initFilterPreview }) =>
    initFilterPreview(cid, designId, filterSettings, filterDesignId)
  );
}

export function getFilterPresets() {
  return getFiltersImpl().then(({ getFilterPresets }) => getFilterPresets());
}

export type ConfigurableFilter = { id: string; range: number[] };

export function getConfigurableFilters() {
  return getFiltersImpl().then(({ getConfigurableFilters }) => getConfigurableFilters());
}

export function generateFilterImage(
  img: HTMLImageElement,
  type: string,
  filterSettings: FilterSettings
) {
  return getFiltersImpl().then(({ generateFilterImage }) =>
    generateFilterImage(img, type, filterSettings)
  );
}

export function generateAndStoreFilterImage(
  img: HTMLImageElement,
  type: string,
  cid: number,
  filterSettings: FilterSettings,
  abort?: { value: boolean }
) {
  return getFiltersImpl().then(({ generateAndStoreFilterImage }) =>
    generateAndStoreFilterImage(img, type, cid, filterSettings, abort)
  );
}
